import React, { useEffect, useRef, useState } from "react";
import "./ocr-file-upload.scss";
import { useStore } from "./../../store/store";
import { useTranslation } from "react-i18next";
import Notification from "../../service/notification";
import { DeleteFilled } from "@ant-design/icons";

import CloudUpload from "./../../assets/images/uploadIcon.svg";

import { List, Typography, Button, Popconfirm, Space, message } from "antd";
const { Text } = Typography;

const OCRFileUpload = (props) => {
  const { user } = useStore();
  const { t } = useTranslation();
  const fileuploadref = useRef(null);
  const [isDragActive, setIsDragActive] = useState(false);
  const [uploadedProgress, setUploadedProgress] = useState(0);
  const [isWaitUpload, setIsWaitUpload] = useState(false);
  const [filesUploaded, seFilesUploaded] = useState();

  const handleUploadClick = () => {
    if (!props.readonly) {
      if (fileuploadref.current) {
        fileuploadref.current.value = null;
        fileuploadref.current.click();
      } else {
        console.error("File input ref is not set.");
      }
    }
  };

  //   ******* Sigle File  Upload ****
  //   const handleFileChange = (fileEvent) => {
  //     console.log("OCR fileEvent", fileEvent);
  //     if (fileEvent?.target?.files && fileEvent.target.files.length > 0) {
  //       let file = fileEvent.target.files[0];
  //       console.log("OCR files", fileEvent.target.files);
  //       //   if (file) {
  //       //     uploadFile(file);
  //       //     // props.updateFormValue(file)
  //       //     // setFileName(file.name)
  //       //     // props.onChange({
  //       //     //     "DocType": file.type,
  //       //     //     "EntityId": file.entityId,
  //       //     //     "FileName": file.name,
  //       //     //     "FileThumbName": file.fileThumbName,
  //       //     //     "FileThumbURL": file.fileThumbURL,
  //       //     //     "FileURL": file.fileURL,
  //       //     //     'size': file.size,
  //       //     //     "Status" : isWaitUpload,
  //       //     //     "file":file
  //       //     // })
  //       //   }
  //     }
  //   };
  //   const uploadFile = (file) => {
  //     if (
  //       file.type === "image/png" ||
  //       file.type === "image/jpg" ||
  //       file.type === "image/jpeg" ||
  //       file.type === "application/pdf"
  //     ) {
  //       if (file.size < 10 * 1024 * 1024) {
  //         props.onChange({
  //           file,
  //           //   fileName: file.name,
  //           //   fileType: file.type,
  //           //   fileSize: file.size,
  //           //   docType: props?.filetype,
  //           //   entityType: props?.entityType,
  //         });
  //       } else {
  //         Notification.error(t("FILE_SIZE_ERROR"));
  //       }
  //     } else {
  //       Notification.error(t("FILE_UPLOAD_NOT_SUPPORTED"));
  //     }
  //   };

  //   MUpltiple Files Upload
  const MAX_FILES = 5;
  const handleFileChange = (fileEvent) => {
    const files = fileEvent?.target?.files;

    if (files && files.length > 0) {
      // 1. Check for max file count
      if (files.length > MAX_FILES) {
        Notification.error(`You can upload a maximum of ${MAX_FILES} files.`);
        fileEvent.target.value = null; // Reset input
        return;
      }

      // 2. Check for unsupported file types
      const unsupportedFiles = Array.from(files).filter((file) => {
        return !(
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "application/pdf"
        );
      });

      if (unsupportedFiles.length > 0) {
        const names = unsupportedFiles.map((file) => file.name).join(", ");
        message.error(`Upload failed. Unsupported files: ${names}`);
        fileEvent.target.value = null;
        return;
      }

      // 3. Proceed Only with Supported  files
      const validFiles = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const result = uploadFile(file);
        if (result) validFiles.push(result);
      }

      // Call props.onChange with all valid files
      if (validFiles.length > 0) {
        props.onChange(validFiles);
      }
    }
  };

  const uploadFile = (file) => {
    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      Notification.error(t("FILE_UPLOAD_NOT_SUPPORTED"));
      return null;
    }

    if (file.size >= 10 * 1024 * 1024) {
      Notification.error(t("FILE_SIZE_ERROR"));
      return null;
    }

    // Return file metadata or actual file depending on need
    return {
      file,
      // fileName: file.name,
      // fileType: file.type,
      // fileSize: file.size,
      // docType: props?.filetype,
      // entityType: props?.entityType,
    };
  };

  return (
    <>
      <div className="ocr-file-upload-wrapper" onClick={handleUploadClick}>
        <div
          style={{
            display: "flex",
            gap: "5px",
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
            padding: props?.accessFile && "10px 0",
          }}
        >
          <img src={CloudUpload} alt="Cloud Upload" />
          <span className="upload-text">
            <Text
              className="upload-text"
              ellipsis={{ tooltip: true }}
              style={{ fontWeight: 500, fontSize: "14px" }}
            >
              {!props?.accessFile
                ? `${t("KYC_CLICK_TO_UPLOAD")}`
                : props?.name
                  ? `${t("KYC_UPLOAD_LBL")} ${props?.name}`
                  : `${t("KYC_UPLOAD_LBL")}`}
            </Text>
            {/* {t("KYC_DRAG_DROP")} */}
          </span>
        </div>
        {
          <span
            className="file-size"
            style={{ margin: "0 auto", fontSize: "12px", lineHeight: "1.56" }}
          >
            {t("KYC_ONLY")} PNG, JPG, JPEG, PDF ({t("KYC_MAX_SIZE")} - 10MB)
          </span>
        }
        <input
          type="file"
          onChange={handleFileChange}
          ref={fileuploadref}
          style={{ display: "none" }}
          multiple={props?.allowSingleFile ? false:true}
          accept=".png,.jpg,.jpeg,.pdf"
        />
      </div>
      {/* {props.uploadedFiles?.map((fileItem, index) => (
        <div key={index} className="uploaded-file-item">
          <span>{fileItem?.file?.name}</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              props.onDelete?.(fileItem?.file?.name);
            }}
          >
            Delete
          </button>
        </div>
      ))} */}

      {props?.uploadedFiles?.length > 0 && (
        <List
          size="small"
          bordered={false}
          dataSource={props.uploadedFiles}
          renderItem={(fileItem, index) => (
            <List.Item
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography.Text ellipsis style={{ maxWidth: "80%" }}>
                {index + 1}. {fileItem?.file?.name}
              </Typography.Text>

              <Button
                type="text"
                size="small"
                icon={<DeleteFilled />}
                danger
                onClick={() => props.onDelete?.(fileItem?.file?.name)}
              />
            </List.Item>
          )}
        />
      )}
    </>
  );
};

export default OCRFileUpload;
